<!-- <span class="{{size}}" *ngIf="displayString != 0">{{displayString}}</span> -->
<span 
class="{{size}}{{color}}" 
matTooltip="{{hoverString}}"
>{{displayString}}</span>